[
  {
    "data_types": [
      "display name",
      "username",
      "password",
      "email address",
      "phone number",
      "date of birth",
      "display language",
      "third-party single sign-in information"
    ],
    "category": "Account Information",
    "purposes": [
      {
        "reason": "Create and manage account",
        "evidence": [33, 34],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [190, 191],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "General public",
        "evidence": [136, 137],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["street address", "contact email address", "contact phone number"],
    "category": "Professional Account Information",
    "purposes": [
      {
        "reason": "Create and manage account",
        "evidence": [39],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [190, 191],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "General public",
        "evidence": [39],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["credit or debit card number", "card expiration date", "CVV code", "billing address"],
    "category": "Payment Information",
    "purposes": [
      {
        "reason": "Process transactions or payments",
        "evidence": [41],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [193],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [152],
        "certainty": "high"
      }
    ],
    "sensitive": "sensitive"
  },
  {
    "data_types": ["biometric information"],
    "category": "Biometric Information",
    "purposes": [
      {
        "reason": "Security and identification",
        "evidence": [45],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "not specified",
        "evidence": "",
        "certainty": "low"
      }
    ],
    "sharing": [
      {
        "party": "not specified",
        "evidence": "",
        "certainty": "low"
      }
    ],
    "sensitive": "sensitive"
  },
  {
    "data_types": [
      "biographical information",
      "employment history",
      "educational history",
      "employment preferences",
      "skills and abilities",
      "job search activity and engagement"
    ],
    "category": "Job Application Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [47],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "not specified",
        "evidence": "",
        "certainty": "low"
      }
    ],
    "sharing": [
      {
        "party": "Others",
        "evidence": [47],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": [
      "posts",
      "comments",
      "audio",
      "broadcast activity",
      "interactions with other users' content",
      "Direct Messages",
      "Encrypted Messages"
    ],
    "category": "User-Generated Content",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [53, 56, 57],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [192],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "General public",
        "evidence": [133, 134, 135, 136, 137, 138, 139],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "IP address",
      "browser type",
      "device and advertising ID",
      "operating system",
      "carrier",
      "language",
      "memory",
      "apps installed",
      "battery level",
      "device address book"
    ],
    "category": "Device Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [63, 64, 65],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Up to 13 months",
        "evidence": [197],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [152],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["location information"],
    "category": "Location Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [67, 68],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Up to 13 months",
        "evidence": [197],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "not specified",
        "evidence": "",
        "certainty": "low"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": ["inferred identity information"],
    "category": "Inferred Identity Information",
    "purposes": [
      {
        "reason": "Security and identification",
        "evidence": [70, 71, 72, 73, 74],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Up to 13 months",
        "evidence": [197],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "not specified",
        "evidence": "",
        "certainty": "low"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": ["log information"],
    "category": "Log Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [76, 77],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Up to 13 months",
        "evidence": [197],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "not specified",
        "evidence": "",
        "certainty": "low"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["ad interactions"],
    "category": "Advertisement Interactions",
    "purposes": [
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [79, 80, 81],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Up to 12 months",
        "evidence": [199],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Advertisers",
        "evidence": [154, 155, 156, 157],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["cookie information"],
    "category": "Cookie Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [83, 84],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Up to 13 months",
        "evidence": [197],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "not specified",
        "evidence": "",
        "certainty": "low"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["third-party content interactions"],
    "category": "Third-Party Content Interactions",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [87],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Up to 12 months",
        "evidence": [199],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [159, 160, 161],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["information from third parties"],
    "category": "Third-Party Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [90, 91, 92, 93, 94, 95, 96, 97],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Up to 12 months",
        "evidence": [200],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [152],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  }
]
